import Vue from 'vue'

const api = new Vue({
    data() {
        return {
            user: null,
            uri: process.env.NODE_ENV === 'development' ? "http://localhost:2916/" : document.location.origin + "/"
        }
    },
    created() {
        this.updateUser();
    },
    methods: {
        getAuth() {
            return {
                headers: new Headers({
                    "Authorization": localStorage.getItem("auth_token")
                })
            };
        },
        getAuthWithJson() {
            return new Headers({
                "Authorization": localStorage.getItem("auth_token"),
                'Content-Type': 'application/json'
            });
        },
        updateUser(uuid) {
            fetch(this.uri + `api/auth/user`, this.getAuth()).then(res => res.json()).then(user => {
                this.user = user;
            }).catch(err => console.log(err));
        },
        setSelectedUser(uuid) {
            fetch(this.uri + `api/auth/user`, {
                headers: this.getAuthWithJson(),
                method: 'POST',
                body: JSON.stringify({uuid})
            }).then(res => res.json()).then(user => {
                this.$api.getUser().user.username = user.username;
                this.$api.getUser().user.uuid = user.uuid;
            });
        },
        getPunishments(category, type, page) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/${type}/list/${page}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getPunishment(category, type, id) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/${type}/single/${id}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getCounts(category, type) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/count${type !== undefined ? '/' + type : ""}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getCountsByUser(category, username, filter) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/count/by/${username}?filter=${filter}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getCountsOnUser(category, username, filter) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/count/on/${username}?filter=${filter}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getPunishmentOnUser(category, username, page, filter) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/user/${username}/${page}?filter=${filter}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getPunishmentByUser(category, username, page, filter) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/staff/${username}/${page}?filter=${filter}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getLogsOnEntry(type, id) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/log/${type}/${id}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        updatePunishment(category, type, id, data) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/${type}/single/${id}`, {
                    headers: this.getAuthWithJson(),
                    method: 'POST',
                    body: JSON.stringify(data)
                }).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        unbanPunishment(category, type, id, data) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/${category}/${type}/single/${id}`, {
                    headers: this.getAuthWithJson(),
                    method: 'DELETE',
                    body: JSON.stringify(data)
                }).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getUser() {
            return {
                user: this.user,
                hasPermission(perms) {
                    return this.user !== undefined && this.user !== null && this.user.tags !== undefined && this.user.tags !== null && (perms.findIndex(p => this.user.tags.includes(p)) !== -1 || this.user.tags.includes("bansite.*"));
                }
            };
        },
        getAutoComplete(name) {
            return new Promise((resolve, reject) => {
                fetch(this.uri + `api/mc/autocomplete/${name}`, this.getAuth()).then(res => res.json()).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            });
        },
        getUri() {
            return this.uri;
        }
    }
});

export default {
    install: function (Vue) {
        Vue.prototype.$api = api
    }
}
